import BaseService from "./base.service";
const service = new BaseService("/members")
export default service;
